/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset, AssetOption, AssetUtils, EntryPoint } from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';
import { call } from 'redux-saga/effects';
import Options from 'core/store/ducks/pi/options';

export default function* getWishlistOptions(asset: Asset, entryPoint?: EntryPoint): SagaIterator<AssetOption[]> {
  try {
    if (entryPoint === EntryPoint.RECORDINGS || entryPoint === EntryPoint.SCHEDULED_RECORDINGS) {
      return [];
    }
    const seriesObject = AssetUtils.isSeries(asset) ? asset : undefined;

    return yield call(Options.getWishlistOptions, asset, seriesObject);
  } catch {
    return [];
  }
}
